import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { BookingForm } from "@/components/site/BookingForm";
import { Reveal, SectionMark } from "@/components/site/Reveal";
import { HOURS, PHONE_SHORT, PHONE_TEL } from "@/data/site";

export default function BookingPage() {
    return (
        <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Seo
                title="Zakaži termin | Ramljak Auto Detailing Centar Ljubuški"
                siteName="Ramljak Auto Detailing Centar"
                description="Zakažite termin za dubinsko čišćenje, poliranje ili detailing vašeg automobila u Ljubuškom — pošaljite zahtjev i potvrdit ćemo termin."
            />
            <section className="grain relative px-5 pb-24 pt-32 md:px-10 md:pb-32 md:pt-44">
                <div className="mx-auto max-w-[1400px]">
                    <Reveal>
                        <SectionMark>( Zakaži termin )</SectionMark>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h1 className="mt-8 font-display text-[11vw] font-light leading-[0.98] tracking-tight text-bone md:text-[5.5vw]">
                            SPREMNI ZA
                            <br />
                            <span className="italic text-bronze">RAZLIKU?</span>
                        </h1>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-7 max-w-md text-sm leading-relaxed text-silver md:text-base">
                            Pošaljite zahtjev putem obrasca — javit ćemo vam se
                            za potvrdu termina. Za hitne upite nazovite nas
                            direktno.
                        </p>
                    </Reveal>

                    <div className="mt-14 grid gap-16 md:mt-20 md:grid-cols-12">
                        <Reveal delay={0.15} className="md:col-span-7">
                            <BookingForm />
                        </Reveal>

                        <Reveal delay={0.25} className="md:col-span-4 md:col-start-9">
                            <aside className="border-t border-white/[0.08] pt-8">
                                <p className="text-[10px] font-medium uppercase tracking-[0.34em] text-bronze">
                                    Ili nazovite
                                </p>
                                <a
                                    href={PHONE_TEL}
                                    data-testid="booking-phone-link"
                                    className="mt-4 inline-block font-display text-3xl font-light tracking-tight text-bone transition-colors hover:text-bronze md:text-4xl"
                                >
                                    {PHONE_SHORT}
                                </a>
                                <dl className="mt-10" data-testid="booking-hours">
                                    {HOURS.map((h) => (
                                        <div
                                            key={h.days}
                                            className="flex items-baseline justify-between border-t border-white/[0.08] py-3 text-sm"
                                        >
                                            <dt className="text-silver">{h.days}</dt>
                                            <dd
                                                className={
                                                    h.time === "Zatvoreno"
                                                        ? "text-silver/60"
                                                        : "text-bone"
                                                }
                                            >
                                                {h.time}
                                            </dd>
                                        </div>
                                    ))}
                                    <div className="border-t border-white/[0.08]" />
                                </dl>
                            </aside>
                        </Reveal>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
